import React from "react";
import FormGarandnawa from "./FormGarandnawa";
import rahel from "./../../../img/rahel1.jpg";
import { ProductConsumer } from "../../../Context/AddProWakel";
import NumberFormat from "react-number-format";
const InputGarandnawa = () => {
  return (
    <>
      <ProductConsumer>
        {(value) => {
          const { RPW_from, RPW_to, RPW_para$, RPW_paraID } = value;
          return (
            <>
              <img src={rahel} alt="rahel" />
              <div className="row mb2">
                <div className="col-4 text-right form-inline "></div>
                <div className="col-4 text-right form-inline ">
                  <div className="form-group ">
                    <label className="font-weight-bold f3 ml5">
                      ڕاپۆرتی پارەگەڕاندنەوە
                    </label>
                  </div>
                </div>
                <div className="col-4 text-right form-inline"></div>
              </div>

              <div
                className="row text-dark font-weight-bold f3 mx-4"
                style={{ border: "2px solid black" }}
              >
                <div className="col-5 text-right  form-inline ">
                  <div className="form-group">
                    <h5 className="font-weight-bold mt1 ml5 ">{RPW_to}</h5>
                    <label className="font-weight-bold mb-2 ml1">
                      : بۆ بەرواری
                    </label>
                  </div>
                </div>

                <div className="col-5 text-right  form-inline ">
                  <div className="form-group">
                    <h5 className="font-weight-bold mt1 ml5  ">{RPW_from}</h5>
                    <label className="font-weight-bold mb-2  ml1">
                      : لە بەرواری{" "}
                    </label>
                  </div>
                </div>
              </div>

              <div className="mt4"></div>
              <FormGarandnawa />
              {/* first row */}
              <div className="row">
                <div className="col-12">
                  <div className="row ">
                    <div className="col-3">
                      <h2 className="bg-white tc">
                        <NumberFormat
                          value={RPW_paraID}
                          className="bg-white f3 font-weight-bold  tc border-0"
                          displayType={"text"}
                          prefix={"ID"}
                          thousandSeparator={true}
                        />
                      </h2>
                    </div>
                    <div className="col-3">
                      <h1 className="text-black tc fk mt-2 ">پارە بە دینار</h1>
                    </div>

                    <div className="col-3 ">
                      <h2 className="bg-white tc">
                        <NumberFormat
                          value={RPW_para$}
                          className="bg-white f3 font-weight-bold  tc border-0"
                          displayType={"text"}
                          prefix={"$"}
                          thousandSeparator={true}
                        />
                      </h2>
                    </div>
                    <div className="col-3">
                      <h1 className="text-black tc fk mt-2">پارە بە دۆلار</h1>
                    </div>
                  </div>
                </div>
              </div>
              <br />
              {/* second row */}
            </>
          );
        }}
      </ProductConsumer>
    </>
  );
};

export default InputGarandnawa;
